import _styled from "styled-components";
const _excluded = ["style", "css"],
  _excluded2 = ["selectedItems", "isOpen", "disabled", "getInputProps", "removeSelectedItem", "getSelectedItemProps", "itemToString", "openMenu", "renderItems", "renderPlaceholder", "style", "placeholder"],
  _excluded3 = ["style", "css", "onChange", "placeholder"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import { defaultLabelGetter } from '../helpers';
import { ControlLabel, Placeholder, SearchInput, Token } from '../layout';
const defaultRenderTokens = _ref => {
  let {
    selectedItems,
    itemToString,
    removeSelectedItem,
    getSelectedItemProps
  } = _ref;
  return selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map((selectedItem, index) => {
    const _getSelectedItemProps = getSelectedItemProps({
        selectedItem,
        index
      }),
      {
        style: tokenStyle,
        css: _ignored
      } = _getSelectedItemProps,
      selectedItemProps = _objectWithoutProperties(_getSelectedItemProps, _excluded);
    return /*#__PURE__*/React.createElement(Token, _extends({
      key: "selected-item-".concat(index),
      style: tokenStyle,
      onClickX: () => removeSelectedItem(selectedItem)
    }, selectedItemProps, {
      content: itemToString === null || itemToString === void 0 ? void 0 : itemToString(selectedItem)
    }));
  });
};
const MultiAutocompleteTokenControlWrapped = (_ref2, ref) => {
  let {
      selectedItems,
      isOpen,
      disabled,
      getInputProps,
      removeSelectedItem,
      getSelectedItemProps,
      itemToString = defaultLabelGetter,
      openMenu,
      renderItems = defaultRenderTokens,
      renderPlaceholder = placeholderProps => /*#__PURE__*/React.createElement(Placeholder, placeholderProps),
      style,
      placeholder
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const [inputStyle, setInputStyle] = useState({
    width: '0ch'
  });
  const hasSelectedItems = selectedItems !== null && selectedItems !== void 0 && selectedItems.length ? selectedItems.length > 0 : false;
  const resizeInput = value => {
    setInputStyle({
      width: "".concat(value.length, "ch")
    });
  };
  const _ref3 = (getInputProps === null || getInputProps === void 0 ? void 0 : getInputProps({
      readOnly: !isOpen,
      onKeyDown: e => {
        if (e.target.value.length) {
          // there is text in the input, don't delete an item
          return;
        }
        if (e.key === 'Backspace' && selectedItems !== null && selectedItems !== void 0 && selectedItems.length) {
          removeSelectedItem(selectedItems[(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) - 1]);
        }
      }
    })) || {
      style: undefined
    },
    {
      style: _ignoredStyle,
      css: _ignoredInputCss,
      onChange: inputOnChange,
      placeholder: inputPlaceholder
    } = _ref3,
    inputProps = _objectWithoutProperties(_ref3, _excluded3);
  const placeholderToUse = placeholder || inputPlaceholder;
  const handleInputOnChange = e => {
    resizeInput(e.target.value);
    inputOnChange === null || inputOnChange === void 0 ? void 0 : inputOnChange(e);
  };
  return /*#__PURE__*/React.createElement(ControlLabel, _extends({
    ref: ref,
    isAutocomplete: true,
    isOpen: isOpen,
    disabled: disabled,
    onClick: () => {
      !isOpen && !disabled && openMenu();
    },
    style: [{
      maxHeight: '6.25em',
      overflow: 'hidden'
    }, style]
  }, props), /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [{
      display: 'flex',
      overflowY: 'auto',
      flexWrap: 'wrap',
      flex: 1,
      maxHeight: 'inherit'
    }]
  }, selectedItems && renderItems({
    isOpen,
    selectedItems,
    getSelectedItemProps,
    removeSelectedItem,
    itemToString
  }), /*#__PURE__*/React.createElement(SearchInput, _extends({
    style: inputStyle,
    onChange: handleInputOnChange,
    showIcon: false,
    isOpen: isOpen,
    disabled: disabled
    // don't show placeholder if we have tokens, otherwise use the given placeholder
    ,
    placeholder: hasSelectedItems ? '' : placeholderToUse
  }, inputProps)), !hasSelectedItems && !isOpen && renderPlaceholder({
    children: placeholderToUse
  })));
};
const MultiAutocompleteTokenControl = /*#__PURE__*/React.forwardRef(MultiAutocompleteTokenControlWrapped);
MultiAutocompleteTokenControl.displayName = 'MultiAutocompleteTokenControl';
MultiAutocompleteTokenControl.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Toggle disabled state */
  disabled: PropTypes.bool,
  /** Toggle loading state */
  isLoading: PropTypes.bool,
  /** Whether Dropdown menu is open */
  isOpen: PropTypes.bool.isRequired,
  /** Function to get props for the menu toggle button */
  getToggleButtonProps: PropTypes.func.isRequired,
  /** Function to get props for the label surrounding the control */
  getLabelProps: PropTypes.func,
  /** The content of te ControlContainer */
  children: PropTypes.any
};
export default MultiAutocompleteTokenControl;
var _StyledDiv = _styled("div").withConfig({
  displayName: "MultiAutocompleteTokenControl___StyledDiv",
  componentId: "sc-1f8qshc-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=MultiAutocompleteTokenControl.js.map